import {
  OnboardingExit,
  OnboardingLocalStorageKeys,
  OnboardingRoute,
  type OnboardingPlan,
  type OnboardingStepCompleted,
} from '../types/onboarding.type';

export const setOnboardingInProgress = (value: boolean) =>
  localStorage.setItem(OnboardingLocalStorageKeys.ONBOARDING_IN_PROGRESS, value.toString());

export const getOnboardingInProgress = (): boolean =>
  localStorage.getItem(OnboardingLocalStorageKeys.ONBOARDING_IN_PROGRESS) === 'true';

export const setOnboardingCurrentStep = (value: OnboardingRoute) =>
  localStorage.setItem(OnboardingLocalStorageKeys.ONBOARDING_CURRENT_STEP, value.toString());

export const getOnboardingCurrentStep = (): OnboardingRoute =>
  localStorage.getItem(OnboardingLocalStorageKeys.ONBOARDING_CURRENT_STEP) as OnboardingRoute;

export const setOnboardingSelectedPlan = (value: OnboardingPlan) =>
  localStorage.setItem(OnboardingLocalStorageKeys.ONBOARDING_SELECTED_PLAN, value);

const removeOnboardingSelectedPlan = () =>
  localStorage.removeItem(OnboardingLocalStorageKeys.ONBOARDING_SELECTED_PLAN);

export const getOnboardingSelectedPlan = (): OnboardingPlan =>
  localStorage.getItem(OnboardingLocalStorageKeys.ONBOARDING_SELECTED_PLAN) as OnboardingPlan;

const clearOldOnboardingLocalStorage = () =>
  localStorage.removeItem(OnboardingLocalStorageKeys.ONBOARDING_BUSINESS_TYPE);

export const clearOnboardingLocalStorage = () => {
  clearOldOnboardingLocalStorage();
  localStorage.removeItem(OnboardingLocalStorageKeys.ONBOARDING_IN_PROGRESS);
  localStorage.removeItem(OnboardingLocalStorageKeys.ONBOARDING_CURRENT_STEP);
  localStorage.removeItem(OnboardingLocalStorageKeys.ONBOARDING_LAST_STEP);
  removeOnboardingSelectedPlan();
};

export const setOnboardingLastStep = (data: OnboardingStepCompleted) =>
  localStorage.setItem(OnboardingLocalStorageKeys.ONBOARDING_LAST_STEP, JSON.stringify(data));

export const getOnboardingLastStep = (): OnboardingStepCompleted | null => {
  const data = localStorage.getItem(OnboardingLocalStorageKeys.ONBOARDING_LAST_STEP);
  return data ? JSON.parse(data) : null;
};

export const getExitInfo = (exit: OnboardingExit) => {
  if (exit === OnboardingExit.CSV) {
    return {
      action: 'csv-upload',
      nextUrl: '/orders',
    };
  }

  if (exit === OnboardingExit.MANUAL) {
    return {
      action: 'manual-order',
      nextUrl: '/orders',
    };
  }

  if (exit === OnboardingExit.API) {
    return {
      action: 'create-api-label',
      nextUrl: '',
    };
  }

  return {
    action: 'connect_store',
    nextUrl: `/connect/${exit}?shippo_location=${encodeURIComponent(OnboardingRoute.connectStore)}`,
  };
};
